import { Text } from '@ltvco/refresh-lib/theme';

import { constants } from 'appConstants';

import {
  BannerContainer,
  HeaderSection,
  StyledBannerIcon,
  StyledTextContainer,
  StyledBodyText,
} from './styledComponents';

export const DigitalFootprintBanner = () => {
  const imgDigitalIdentityLogo = constants?.images?.imgDigitalIdentityLogo;

  return (
    <BannerContainer
      sx={{
        padding: {
          xs: '20px 0px',
          sm: '20px 16px',
        },
      }}
    >
      <StyledBannerIcon src={imgDigitalIdentityLogo} alt="" />

      <StyledTextContainer>
        <HeaderSection>
          <Text variant="h4" marginBottom={0}>
            Monitor Your Digital Footprint
          </Text>
        </HeaderSection>

        <StyledBodyText variant="body2">
          Your digital footprint is composed of data that is publicly available
          on the internet. NumberGuru allows you to monitor this data for
          changes, or when new information becomes available.
        </StyledBodyText>
      </StyledTextContainer>
    </BannerContainer>
  );
};

export default DigitalFootprintBanner;
